/* Add class to sticky header when it's stuck. */
const observeEl = document.getElementById("shopify-section-announcement-bar");
const observer = new IntersectionObserver(
  function (e) {
    //console.log(e);
    //console.log(e[0].intersectionRatio);
    if(e[0].intersectionRatio <=0) {
      document.getElementById("mega-menu").classList.add("is-pinned");
      document.body.classList.add('is-pinned');
    } else {
      document.getElementById("mega-menu").classList.remove("is-pinned");
      document.body.classList.remove('is-pinned');
    }
  },
  { threshold: [0], rootMargin: '0px 0px 0px 0px' }
);
observer.observe(observeEl);

//Mobile Menu Toggle.
const navtoggle = document.getElementById("navtoggle");
navtoggle.addEventListener("click", function (e) {
  e.preventDefault();
//  document.documentElement.classList.toggle('menu-opened');
  document.body.classList.toggle('menu-opened');
});

//Sub-menu accordions
const mobileSubMenus = document.querySelectorAll("#mega-menu nav .icon");
for (var i = 0; i < mobileSubMenus.length; i++) {
  mobileSubMenus[i].addEventListener('click', function (e) {
    e.preventDefault();
    mobileSubMenus.forEach((el) => {
      if (el === this)
        this.parentElement.parentElement.classList.toggle('submenu-opened');
      else
        el.parentElement.parentElement.classList.remove("submenu-opened");
    });
  });
}

//Search Box
const search = document.querySelector("#menu-search");
const searchBtns = document.querySelectorAll("#menu-search a.search-open, #menu-search .icon-close-small");
for (var i = 0; i < searchBtns.length; i++) {
  searchBtns[i].addEventListener('click', handleSeachToggle);
}
function handleSeachToggle(e) {
  e.preventDefault();
  search.classList.toggle('search-open');
}

/*
//Stop transitions on window resize
(function() {
  const classes = document.body.classList;
  let timer = null;
  window.addEventListener('resize', function () {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    } else {
      classes.add('stop-transitions');
    }

    timer = setTimeout(() => {
      classes.remove('stop-transitions');
      timer = null;
    }, 100);
  });
})();
*/
